import { ReactElement } from 'react'
import { IconButton } from '../../../components'
import { getSubjectLogo, capitalize } from '../../../helpers'
import { SubjectGroupProps } from './typings'

const SubjectGroup = ({
  subjectName,
  handleSelect
}: SubjectGroupProps): ReactElement => {
  return (
    <>
      <IconButton
        src={getSubjectLogo({
          subject: subjectName
        })}
        isBold
        title={capitalize(subjectName)}
        onSubmit={handleSelect}
      />
    </>
  )
}

export default SubjectGroup
